import React from "react";
import { Circle } from "rc-progress";
import IconButton from "@material-ui/core/IconButton";
import { ReactComponent as LockIcon } from "../../../../../../../images/settings-icons/lock-icon.svg";
import { ReactComponent as LockOpenIcon } from "../../../../../../../images/settings-icons/unlock-icon.svg";
import {
  MacroItem as MacroItemStyled,
  CircleContainer,
  CircleValue,
  MacroLabel,
  GramsInputContainer,
  MacroInput,
  GramsLabel,
} from "./styled-components";

const MacroItemComponent = ({
  macro,
  grams,
  gramsInputValue,
  percentage,
  viewMode,
  locked,
  onLockToggle,
  onGramsChange,
  onPercentageChange,
  colors,
}) => {
  const { strokeColor, label } = colors;
  const cappedPercentage = Math.min(100, percentage);

  return (
    <MacroItemStyled>
      <CircleContainer style={{ opacity: locked ? 0.5 : 1 }}>
        <Circle
          percent={cappedPercentage}
          trailWidth={6}
          strokeWidth={6}
          strokeColor={strokeColor}
          trailColor="#cbcddc"
          style={{ width: 110, height: 110 }}
        />
        <CircleValue>
          {viewMode === "percent" ? Math.round(grams) : `${cappedPercentage}%`}
          <MacroLabel>{label}</MacroLabel>
        </CircleValue>
      </CircleContainer>
      {viewMode === "grams" ? (
        <>
          <GramsInputContainer>
            <MacroInput
              value={gramsInputValue}
              onChange={(e) => onGramsChange(macro, e.target.value)}
              maxLength={4}
              disabled={locked}
            />
            <GramsLabel>g</GramsLabel>
          </GramsInputContainer>
          <IconButton
            key={`lock-${macro}-grams`}
            aria-label={`lock-${macro}-grams`}
            color="inherit"
            onClick={onLockToggle}
            size="medium"
          >
            {locked ? (
              <LockIcon style={{ width: 24, height: 24 }} />
            ) : (
              <LockOpenIcon style={{ width: 24, height: 24 }} />
            )}
          </IconButton>
        </>
      ) : (
        <>
          <GramsInputContainer>
            <MacroInput
              value={cappedPercentage}
              onChange={(e) => onPercentageChange(macro, e.target.value)}
              disabled={locked}
            />
            <GramsLabel>%</GramsLabel>
          </GramsInputContainer>
          <IconButton
            key={`lock-${macro}`}
            aria-label={`lock-${macro}`}
            color="inherit"
            onClick={onLockToggle}
            size="medium"
          >
            {locked ? (
              <LockIcon style={{ width: 24, height: 24 }} />
            ) : (
              <LockOpenIcon style={{ width: 24, height: 24 }} />
            )}
          </IconButton>
        </>
      )}
    </MacroItemStyled>
  );
};

export default MacroItemComponent;
